__turbopack_context__.v({
  "backgroundImageAndGradients": "NeQzxG_backgroundImageAndGradients",
  "container": "NeQzxG_container",
  "content": "NeQzxG_content",
  "styledButton": "NeQzxG_styledButton",
  "subTitle": "NeQzxG_subTitle",
  "title": "NeQzxG_title",
});
